import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/evernote': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M120.8 132.2c1.6 22.3-17.6 21.6-21.6 21.6-68.9 0-73.6-1-83.6 3.3-0.6 0.2-0.7 0-0.4-0.4l108.5-110.3c0.4-0.4 0.6-0.2 0.4 0.4-4.3 10-3.3 15.1-3.3 85.4zM199.8 440.2c-14.7-37.1 13-76.9 52.5-76.6 17.5 0 22.6 23.2 8 31.4-6.2 3.3-25 1.7-25.1 19.2-0.1 17.1 19.7 25 31.2 24.9h0c25.2 0 45.6-20.4 45.6-45.6v0-0.1c0-11.6-7.8-47.2-47.5-55.3-7.7-1.5-65-6.4-68.3-50.5-3.7 16.9-17.4 63.5-43.1 69.1-8.7 1.9-69.7 7.6-112.9-36.8 0 0-18.6-15.2-28.2-58-3.4-15.8-9.3-39.7-11.1-62 0-18 11.1-30.5 25.1-32.2 81 0 90 2.3 101-7.8 9.8-9.2 7.8-15.5 7.8-102.8 1-8.3 7.8-30.8 53.4-24.1 6 0.9 31.9 4.2 37.5 30.6l64.3 11.2c20.4 3.7 70.9 7 80.6 57.9 22.7 121.1 8.9 238.5 7.8 238.5-16 114.4-111.1 108.8-111.1 108.8-18.9-0.2-54.3-9.4-67.3-39.8zM280.8 235.4c-1 1.9-2.2 6 0.9 7 14.1 4.9 39.8 6.8 45.9 5.5 3.1-0.3 3-4.4 2.5-6.7-3.5-21.8-40.8-26.5-49.2-5.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/evernote.js
// module id = 817
// module chunks = 0